
const CoreDebounceButton = () =>
  import("~~/_core/collections/components/elements/button/DebounceButton.vue");

export default {
  components: { CoreDebounceButton },

  data() {
    return {
      errorMsg: "",
      model: {
        password: "",
      },
    };
  },

  computed: {
    configs() {
      return this.$store.getters["config/getConfigs"];
    },
  },

  methods: {
    save() {
      if (this.configs.length <= 0) {
        this.$toast.open({ message: this.$t("config.no_setup_password") });
      }

      const configPassword = this.$get(this.configs[0], "password");
      // Check password is correct
      if (this.model.password == configPassword) {
        this.$store.dispatch("admin/setAdmin", { signed: 1 });
        this.$store.commit("temp/PUT", { password: 1 });
        this.$emit("close");
      } else {
        // this.close(false)
        this.errorMsg = this.$t("config.wrong");
      }
    },
  },
};
